class Recommendation {
  static RECOMMEND_TYPE_APPROVAL = 1
  static RECOMMEND_TYPE_REJECTION = 2

  constructor (caseId, type, comment) {
    this.caseId = caseId
    this.type = type
    this.comment = comment
  }

  get isApproval () {
    return this.type.value === Recommendation.RECOMMEND_TYPE_APPROVAL
  }

  get isRejection () {
    return this.type.value === Recommendation.RECOMMEND_TYPE_REJECTION
  }

  static asRecommendations (json) {
    return json.map(jsonItem => {
      return Recommendation.asRecommendation(jsonItem)
    })
  }

  static asRecommendation (json) {
    return new Recommendation(
      json.case,
      json.recommendation_type,
      json.comment
    )
  }
}

export {
  Recommendation
}
